import React, { Fragment } from "react"

import { Messages } from "@sogei/react-web-components-catalog"

interface ErroriProps {
    controllo: boolean
    errore: boolean
    messaggio?: string
}

function Errori(props: ErroriProps) {
    let controllo = props.controllo
    let errore = props.errore
    let messaggio = props.messaggio

    //console.log("controllo",controllo);
    //console.log("errore",errore);
    return (
        <Fragment>
            {controllo === false ? (
                <Messages
                    successMessages={[]}
                    infoMessages={[]}
                    warningMessages={[]}
                    dangerMessages={[{ text: messaggio }]}
                ></Messages>
            ) : (
                <span></span>
            )}

            {errore === true ? (
                <Messages
                    successMessages={[]}
                    infoMessages={[]}
                    warningMessages={[]}
                    dangerMessages={[{ text: "Si è verificato un errore" }]}
                ></Messages>
            ) : (
                <span></span>
            )}
        </Fragment>
    )
}
export default Errori
